// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
export enum NumberOfPortions {
  Two = 2,
  Four = 4,
}
